import {TempusDominus} from "@eonasdan/tempus-dominus";
import Lang from "@vendors-fr/messages";
import {AlertMessage} from "@plugins-fr/alertMessage";
import {waca} from "@plugins-fr/regExp";
import {recordUserEventTrack} from "@commons/userTracks/userTrack";
import {orderPageOrderPaidSubmit} from "@commons/userTracks/eventActionName";

const ShopAtmIsPayData = {
    selector: {
        'atmName': () => {
            return '.js_atm_name';
        },
        'atmBank': () => {
            return '.js_atm_bank';
        },
        'atmAccount': () => {
            return '.js_atm_account';
        },
        'atmPayTime': () => {
            return '.js_atm_pay_time';
        },
        'atmShopsAccount': () => {
            return '.js_atm_shops_account';
        }
    },
    get: {
        'atmName': () => {
            return $.trim($(ShopAtmIsPayData.selector.atmName()).val());
        },
        'atmBank': () => {
            return $.trim($(ShopAtmIsPayData.selector.atmBank()).val());
        },
        'atmAccount': () => {
            return $.trim($(ShopAtmIsPayData.selector.atmAccount()).val());
        },
        'atmPayTime': () => {
            return $.trim($(ShopAtmIsPayData.selector.atmPayTime()).val());
        },
        'atmShopsAccount': () => {
            return $(ShopAtmIsPayData.selector.atmShopsAccount() + ' option:selected').val();
        },
        'atmShopsAccountLength': () => {
            return $(ShopAtmIsPayData.selector.atmShopsAccount()).length;
        }
    }
};


export class ShopAtmIsPay {
    defaultSetting = {
        'orderNo': '',
        'locale': '',
        'shopAtm': [],
        'hasPayTime': false,
        'orderATMAjaxUrl': '',
        'orderQueryToken': '',
        'successCallback': () => {
        },
    }

    constructor(setting) {
        this.setting = Object.assign({}, this.defaultSetting, setting);

        this.validator = new ShopAtmIsPayValidator({
            'hasPayTime': this.setting.hasPayTime
        });
    }

    bindEvents() {
        this.bindAtmPayTimeEvent();
        this.bindChangeAtmChangeEvent();
        this.bindClickIsPayButtonEvent();
    }

    bindAtmPayTimeEvent() {
        let locale = 'en';
        if (this.setting.locale === 'tw') {
            locale = 'zh-tw'
        } else if (this.setting.locale === 'cn') {
            locale = 'zh-cn'
        }

        if ($(ShopAtmIsPayData.selector.atmPayTime()).length > 0) {
            new TempusDominus(
                document.getElementById('atm_pay_time'), {
                    container: document.querySelector('.date_picker_area'),
                    display: {
                        sideBySide: false,
                        viewMode: 'calendar',
                        keepOpen: false,
                        buttons: {
                            today: false,
                            clear: false,
                            close: false
                        },
                        icons: {
                            time: "icon-access_time",
                            date: 'icon-date_range',
                            up: 'icon-arrow_upward',
                            down: 'icon-arrow_downward',
                            previous: 'icon-arrow_back',
                            next: 'icon-arrow_forward',
                            today: 'icon-event',
                            clear: 'icon-delete_forever',
                            close: 'icon-clear'
                        },
                        components: {
                            calendar: true,
                            date: true,
                            month: true,
                            year: true,
                            decades: true,
                            clock: true,
                            hours: true,
                            minutes: true,
                            seconds: false,
                        },
                        theme: 'light'
                    },
                    localization: {
                        locale: locale,
                        format: 'yyyy-MM-dd HH:mm',
                        hourCycle: 'h23',
                        dayViewHeaderFormat: {month: 'long', year: 'numeric'}
                    },
                    useCurrent: false,
                }
            );
        }
    }

    bindChangeAtmChangeEvent() {
        $('.js_atm_Fields, .js_atm_shops_account').change(() => {
            this.validator.check();
        });
    }

    bindClickIsPayButtonEvent() {
        $('.js_ispay_button').click(() => {

            if (!this.validator.check()) {
                return;
            }

            let ATM = {
                'name': ShopAtmIsPayData.get.atmName(),
                'bank': ShopAtmIsPayData.get.atmBank(),
                'account': ShopAtmIsPayData.get.atmAccount()
            };

            if (ShopAtmIsPayData.get.atmShopsAccountLength() > 0) {
                ATM['shops_account'] = this.setting.shopAtm['atmInfo'][ShopAtmIsPayData.get.atmShopsAccount()];
            }

            if (this.setting.hasPayTime) {
                ATM['payment_at'] = ShopAtmIsPayData.get.atmPayTime();
            }

            $.ajax({
                type: 'POST',
                url: this.setting.orderATMAjaxUrl,
                data: {
                    ATM: ATM,
                    no: this.setting.orderNo,
                    order_query_token: this.setting.orderQueryToken
                },
                dataType: 'json',
                success: (data) => {
                    if (data.ErrorCode == 1) {
                        recordUserEventTrack(orderPageOrderPaidSubmit, this.setting.orderATMAjaxUrl, {
                            'order_no': String(this.setting.orderNo),
                        });

                        new AlertMessage({
                            'title': Lang.get('frontend.order.ATM.toPending.info'),
                            confirm: () => {
                                this.setting.successCallback();
                            }
                        }, {
                            'type': 'success'
                        }).handle();
                    } else if (data.ErrorCode == 3) {
                        new AlertMessage({
                            'title': Lang.get('frontend.errormsg.order.query.tokenInvalid'),
                            confirm: () => {
                                this.setting.successCallback()
                            }
                        }).handle();
                    } else {
                        new AlertMessage({
                            'title': Lang.get('frontend.errormsg.ATM.toPending.error'),
                            confirm: () => {
                                this.setting.successCallback()
                            }
                        }).handle();
                    }


                }
            });
        });
    }
}

class ShopAtmIsPayValidator {
    defaultSetting = {
        'hasPayTime': false
    }

    errorMessage = {
        'isRequired': Lang.get('frontend.errormsg.isRequired'),
        'paymentAtFormat': Lang.get('frontend.errormsg.order.order.payment_at.format'),
    }

    constructor(setting) {
        this.checkStatus = true;
        this.setting = Object.assign({}, this.defaultSetting, setting);
    }

    init() {
        this.checkStatus = true;
    }

    check() {
        this.init();
        this.checkAtmName();
        this.checkAtmBank();
        this.checkAtmAccount();
        this.checkAtmPayTime();
        this.checkAtmShopAccount();

        return this.checkStatus;
    }

    checkAtmName() {
        const errorMessageDom = $('.js_atm_name_group');

        if (ShopAtmIsPayData.get.atmName() === '') {
            this.checkStatus = false;
            this.showErrorMessage(errorMessageDom, this.errorMessage.isRequired);
            return false;
        }

        this.hideErrorMessage(errorMessageDom)
        return true;
    }

    checkAtmBank() {
        const errorMessageDom = $('.js_atm_bank_group');

        if (ShopAtmIsPayData.get.atmBank() === '') {
            this.checkStatus = false;
            this.showErrorMessage(errorMessageDom, this.errorMessage.isRequired);
            return false;
        }

        this.hideErrorMessage(errorMessageDom)
        return true;
    }

    checkAtmAccount() {
        const errorMessageDom = $('.js_atm_account_group');

        if (ShopAtmIsPayData.get.atmAccount() === '') {
            this.checkStatus = false;
            this.showErrorMessage(errorMessageDom, this.errorMessage.isRequired);
            return false;
        }

        this.hideErrorMessage(errorMessageDom)
        return true;
    }

    checkAtmPayTime() {
        const errorMessageDom = $('.js_atm_pay_time_group');

        if (this.setting.hasPayTime) {
            const atmPayTime = ShopAtmIsPayData.get.atmPayTime();

            if (atmPayTime === '') {
                this.checkStatus = false;
                this.showErrorMessage(errorMessageDom, this.errorMessage.isRequired);
                return false;
            } else if (!waca.regexValidator.datetimeToMinute(atmPayTime)) {
                this.checkStatus = false;
                this.showErrorMessage(errorMessageDom, this.errorMessage.paymentAtFormat);
                return false;
            }
        }

        this.hideErrorMessage(errorMessageDom)
        return true;
    }

    checkAtmShopAccount() {
        const errorMessageDom = $('.js_atm_multiple_group');

        if (ShopAtmIsPayData.get.atmShopsAccountLength() > 0 && ShopAtmIsPayData.get.atmShopsAccount() === '') {
            this.checkStatus = false;
            this.showErrorMessage(errorMessageDom)
            return false;
        }

        this.hideErrorMessage(errorMessageDom)
        return true;
    }

    showErrorMessage(FieldName, ErrorName) {
        FieldName.addClass('form_valid');
        FieldName.find('.js_order_message').find('span').html(ErrorName);
    }

    hideErrorMessage(FieldName) {
        FieldName.removeClass('form_valid');
    }
}
